import React, { useState, useEffect, useRef } from 'react';
import './AddCategoryPopup.css';
import languageManager from '../../utils/languageManager';

// 分类图标列表
export const categoryIcons = [
  { id: 1, icon: 'fas fa-home' },
  { id: 2, icon: 'fas fa-gamepad' },
  { id: 3, icon: 'fas fa-clock' },
  { id: 4, icon: 'fas fa-briefcase' },
  { id: 5, icon: 'fas fa-tv' },
  { id: 6, icon: 'fas fa-shopping-bag' },
  { id: 7, icon: 'fas fa-plane' },
  { id: 8, icon: 'fas fa-atom' },
  { id: 9, icon: 'fas fa-print' },
  { id: 10, icon: 'fas fa-random' },
  { id: 11, icon: 'fas fa-shield-alt' },
  { id: 12, icon: 'fas fa-crown' },
  { id: 13, icon: 'fas fa-cloud' },
  { id: 14, icon: 'fas fa-image' },
  { id: 15, icon: 'fas fa-star' },
  { id: 16, icon: 'fas fa-gift' },
  { id: 17, icon: 'fas fa-code' },
  { id: 18, icon: 'fas fa-at' },
  { id: 19, icon: 'fas fa-award' },
  { id: 20, icon: 'fas fa-user-graduate' },
  { id: 21, icon: 'fas fa-cube' },
  { id: 22, icon: 'fas fa-calendar' },
  { id: 23, icon: 'fas fa-desktop' },
  { id: 24, icon: 'fas fa-coffee' },
  { id: 25, icon: 'fas fa-user' },
  { id: 26, icon: 'fas fa-building' },
  { id: 27, icon: 'fas fa-globe' },
  { id: 28, icon: 'fas fa-mobile-alt' },
  { id: 29, icon: 'fas fa-server' },
  { id: 30, icon: 'fas fa-vial' },
  { id: 31, icon: 'fas fa-palette' },
  { id: 32, icon: 'fas fa-chart-bar' },
  { id: 33, icon: 'fas fa-comments' },
  { id: 34, icon: 'fas fa-pen-nib' },
  { id: 35, icon: 'fas fa-book' },
  { id: 36, icon: 'fas fa-music' },
  { id: 37, icon: 'fas fa-heart' },
  { id: 38, icon: 'fas fa-th-large' },
  { id: 39, icon: 'fas fa-mobile' },
  { id: 40, icon: 'fas fa-video' }
];

// 添加分类弹窗组件
const AddCategoryPopup = ({ onClose, onSave, editItem = null }) => {
  const [categoryName, setCategoryName] = useState('');
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const popupRef = useRef(null);

  // 如果是编辑模式，填充现有数据
  useEffect(() => {
    if (editItem) {
      setCategoryName(editItem.text);
      setSelectedIcon(editItem.icon);
    }
  }, [editItem]);

  useEffect(() => {
    // 点击弹窗外部区域关闭弹窗
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 2000);
  };

  const handleSave = () => {
    if (!categoryName.trim() && !selectedIcon) {
      showToastMessage(languageManager.t('categoryPopup.enterNameAndIcon'));
      return;
    }
    
    if (!categoryName.trim()) {
      showToastMessage(languageManager.t('categoryPopup.enterCategoryName'));
      return;
    }
    
    if (!selectedIcon) {
      showToastMessage(languageManager.t('categoryPopup.selectIcon'));
      return;
    }

    onSave({
      id: editItem ? editItem.id : null,
      name: categoryName,
      icon: selectedIcon
    });
    setCategoryName('');
    setSelectedIcon(null);
  };

  const handleIconSelect = (icon) => {
    setSelectedIcon(icon);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (!categoryName.trim() && !selectedIcon) {
        showToastMessage('请输入分类名称并选择图标');
        return;
      }
      
      if (!categoryName.trim()) {
        showToastMessage('请输入分类名称');
        return;
      }
      
      if (!selectedIcon) {
        showToastMessage('请选择图标');
        return;
      }
      
      handleSave();
    }
  };

  return (
    <div className="popup-overlay">
      <div className="add-category-popup" ref={popupRef}>
        {/* 关闭按钮 */}
        <button className="popup-close-button" onClick={onClose}>
          ×
        </button>
        
        {showToast && (
          <div className="toast-message">
            {toastMessage}
          </div>
        )}
        <div className="popup-header">{languageManager.t('categoryPopup.categoryIcon')}</div>
        <div className="icons-grid">
          {categoryIcons.map((iconItem) => (
            <div 
              key={iconItem.id}
              className={`icon-item ${selectedIcon === iconItem.icon ? 'selected' : ''}`}
              onClick={() => handleIconSelect(iconItem.icon)}
            >
              <i className={iconItem.icon}></i>
            </div>
          ))}
        </div>
        <div className="popup-header">{languageManager.t('categoryPopup.categoryName')}</div>
        <input
          type="text"
          className="category-name-input"
          placeholder={languageManager.t('categoryPopup.enterCategoryName')}
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          onKeyDown={handleKeyDown}
          maxLength={10}
        />
        <div className="name-limit-tip">{languageManager.t('categoryPopup.nameLimitTip')}</div>
        <button 
          className="save-button"
          onClick={handleSave}
        >
          {languageManager.t('categoryPopup.save')}
        </button>
      </div>
    </div>
  );
};

export default AddCategoryPopup; 